<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :theme="theme"
        :buttons="buttons"
        :value="sourceOfIncomeA"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  // Name
  name: 'EmploymentStatus',

  // Components
  components: {
    AppButton,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    buttonList,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'What Is Your Employment Status?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'setSourceOfIncome',
      buttonListDataLayerStepName: `spring_${this.eventPrefix}_employment_status`,
      buttonListFieldName: 'sourceOfIncomeA',
      buttons: [{
        text: 'Employed',
        value: 'Employed',
        dataLayer: 'employed'
      }, {
        text: 'Self Employed',
        value: 'Self Employed',
        dataLayer: 'self_employed'
      }, {
        text: 'Retired / Pension',
        value: 'Retired/Pension',
        dataLayer: 'retired'
      }, {
        text: 'Long Term Disability',
        value: 'Long Term Disability',
        dataLayer: 'long_term_disability'
      }, {
        text: 'Employment Insurance',
        value: 'Employment Insurance',
        dataLayer: 'employment_insurance'
      }, {
        text: 'Other',
        value: 'Other',
        dataLayer: 'other'
      }, {
        text: 'No Current Income',
        value: 'No Current Income',
        dataLayer: 'no_current_income'
      }]
    }
  },

  // Computed
  computed: {
    sourceOfIncomeA () {
      return this.$store.state.employment.source_of_income_a
    },

    sourceOfIncome () {
      return this.$store.state.employment.source_of_income
    },

    updateLeadPayload () {
      return { source_of_income: this.sourceOfIncome }
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  methods: {
    handleContinue () {
      // Reset source_of_income_b in case user goes back
      // and selects a different employment status to prevent
      // skipping the "other" screen.
      this.$store.dispatch('resetSourceOfIncomeB', '')

      if (this.sourceOfIncomeA === 'Employment Insurance' || this.sourceOfIncomeA === 'Other') {
        this.$_navigation_handleNext(this.$_buttonList_dataLayerObject)
      } else {
        this.$_loans_updateLead(this.updateLeadPayload, this.$_buttonList_dataLayerObject)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
